/** True when this file's digest matches the other placement in the same editor session. */
export function isDuplicateCreativeSlot(
  otherSlotDigest: string | undefined | null,
  fileDigest: string
): boolean {
  const other = otherSlotDigest?.trim();
  if (!other) return false;
  return other === fileDigest;
}

function readArrayBuffer(file: Blob): Promise<ArrayBuffer> {
  if (typeof file.arrayBuffer === "function") return file.arrayBuffer();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file);
  });
}

/** Copy into this realm so SubtleCrypto accepts bytes from an older File implementation. */
async function fileBytes(file: Blob): Promise<Uint8Array> {
  const buffer = await readArrayBuffer(file);
  const copy = new Uint8Array(buffer.byteLength);
  copy.set(new Uint8Array(buffer));
  return copy;
}

export async function sha256Hex(file: Blob): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", await fileBytes(file));
  return Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("");
}
